import { EMOJIS } from './emoji-list';

/**
 * 表情选择行 —— 人工模式输入栏上方常用 emoji 面板。
 * 复用 web 客服的 dcs-web-emoji-* 样式(CSS 在 shadow root 全局可见),web 与 digital 共用。
 * 点击某表情即回调 onSelect(emoji);Twemoji 彩色字体由 main.tsx 全局注入,无需本组件处理。
 */
export function EmojiPicker({ onSelect }: { onSelect: (emoji: string) => void }) {
  return (
    <div class="dcs-web-emoji-row">
      {EMOJIS.map((e) => (
        <button
          key={e}
          type="button"
          class="dcs-web-emoji-btn"
          onClick={() => onSelect(e)}
        >
          {e}
        </button>
      ))}
    </div>
  );
}
